import { JetView, plugins } from 'webix-jet'; // Importing JetView and plugins from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration
import MenuView from 'jet-views/menu'; // Importing MenuView component
import ToolView from 'jet-views/toolbar'; // Importing ToolView component

/**
 * Class representing the providersThirdView.
 * @extends JetView
 */
export default class providersThirdView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme from app config
        const screen = this.app.config.size; // Screen size from app config
        webix.ui.fullScreen(); // Set the UI to full screen mode

        return {
            type: 'clean', // Clean layout type
            view: 'form', // Form view
            id: 'a10', // Unique identifier for the form
            scroll: 'y', // Enable vertical scrolling
            rows: [
                {
                    type: 'wide', // Wide layout type
                    responsive: 'a10', // Responsive layout identifier
                    margin: 10, // Margin around the layout
                    cols: [
                        {
                            localId: 'inner:layout', // Local identifier for the inner layout
                            gravity: 4, // Gravity for resizing
                            type: 'wide', // Wide layout type
                            rows: [
                                {
                                    view: 'tabbar', // Tabbar view
                                    localId: 'tabbar', // Local identifier for the tabbar
                                    height: screen == 'small' ? 75 : 45, // Dynamic height based on screen size
                                    options: [
                                        {
                                            id: 'accounting.providers_copy', // Identifier for the first tab
                                            value: _('Proveedores'), // Localized value for the first tab
                                        },
                                        {
                                            id: 'accounting.productsThirdBetShop', // Identifier for the second tab
                                            value: _('Productos Terceros'), // Localized value for the second tab
                                        },
                                        {
                                            id: 'accounting.productsThirdByBetShop', // Identifier for the third tab
                                            value: _('Productos Terceros Punto de Venta'), // Localized value for the third tab
                                        },
                                    ],
                                },
                                { $subview: true }, // Placeholder for subview
                            ],
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view.
     */
    init() {
        this.use(plugins.Menu, this.$$('tabbar')); // Use Menu plugin with the tabbar
    }
}

// FILE DOCUMENTED
